import React from "react";

class ClickTest extends React.PureComponent {
  componentDidMount() {
    var loadScript = function (src) {
      var tag = document.createElement("script");
      tag.async = false;
      tag.src = src;
      document.getElementsByTagName("body")[0].appendChild(tag);
    };

    loadScript("//code.jquery.com/jquery-1.12.4.min.js");

    function createButton(cps) {
      // Remove Whatever is in the tweeetbox div if theres somethign
      //there to avoid adding multiple tweetbuttons

      var tweetdiv = document.getElementById("tweet-box");
      tweetdiv.innerHTML = "";

      var elem = document.getElementById("twitterbutton");
      if (elem != null) {
        elem.parentNode.removeChild(elem);
      }

      // Create a New Tweet Element
      var link = document.createElement("a");
      link.setAttribute("href", "https://twitter.com/share");
      link.setAttribute("class", "twitter-share-button");
      link.setAttribute("style", "margin-top:5px;");
      link.setAttribute("id", "twitterbutton");
      link.setAttribute(
        "data-text",
        "I just got " + cps + " CPS on the Kohi Click Test"
      );
      link.setAttribute("data-via", "ghastapp");
      link.setAttribute("data-size", "large");

      // Put it inside the twtbox div
      tweetdiv.appendChild(link);

      window.twttr.widgets.load(); //very important
    }

    const doClickStuff = () => {
      var start;
      var countdown;
      var clicks = 0;
      var active = false;
      window.$("#clicker").click(function () {
        if (!active) {
          start = window.$.now();
          active = true;
          countdown = setInterval(function () {
            timer();
          }, 50);
          clicks = 0;
        }
        clicks++;
        window.$("#clicks").html(clicks);
      });

      window.$("#reset").click(function () {
        if (!active) {
          window.$("#reset").hide();
          window.$("#tweet-box").hide();
          window.$("#clicker").show();
          window.$(".progress").show();
          clicks = 0;
          window.$("#clicks").html(clicks);
          clearInterval(countdown);
        }
      });

      function timer() {
        if (window.$.now() - start > 10000) {
          window.$("#clicker").hide();
          window.$(".countdown").hide();
          window.$("#countdown").html("");
          window.$("#reset").show();
          window.$("#clicks").html(clicks / 10 + " CPS");
          active = false;
          clearInterval(countdown);
          document.getElementById("clicker").innerHTML = "Click Here";
          createButton(clicks / 10);
          window.$("#tweet-box").show();
          return;
        }
        var t = (start - window.$.now()) / 1000;
        window.$("#countdown").html(Math.abs(t));
      }
    };

    const thing = () => {
      if (
        typeof window.$ !== "undefined" &&
        typeof window.twttr !== "undefined"
      ) {
        doClickStuff();
      } else {
        setTimeout(thing, 500);
      }
    };

    thing();
  }

  shouldComponentUpdate() {
    return false;
  }

  render() {
    return (
      <div>
        <span className="clicktest-pretend-h3">
          Clicks: <span id="clicks">0</span> <span id="tweet-box" />
        </span>
        <button
          id="clicker"
          type="button"
          className="clicktest-box btn btn-default"
          style={{ width: "100%", height: 300, display: "inline-block" }}
        >
          Click Here
        </button>
        <button
          id="reset"
          type="button"
          className="clicktest-reset-button btn btn-default"
          style={{ display: "none" }}
        >
          Restart Test
        </button>
        <span id="countdown" className="clicktest-counter text-center" />
      </div>
    );
  }
}

export default ClickTest;



/** WEBPACK FOOTER **
 ** ./src/views/pages/kohi-click-test/click-test.js
 **/